const types = {
  CHECKOUT_SUMMARY: 'CHECKOUT_SUMMARY',
  CHECKOUT_SUMMARY_RESPONSE: 'CHECKOUT_SUMMARY_RESPONSE',
  CHECKOUT_SUMMARY_CLEAR: 'CHECKOUT_SUMMARY_CLEAR',

  PAYMENT_INTENT: 'PAYMENT_INTENT',
  PAYMENT_INTENT_RESPONSE: 'PAYMENT_INTENT_RESPONSE',
  PAYMENT_INTENT_CLEAR: 'PAYMENT_INTENT_CLEAR',

  PI_DIRECT_CHECKOUT: 'PI_DIRECT_CHECKOUT',
  PI_DIRECT_CHECKOUT_RESPONSE: 'PI_DIRECT_CHECKOUT_RESPONSE',
  PI_DIRECT_CHECKOUT_CLEAR: 'PI_DIRECT_CHECKOUT_CLEAR',

  PROVIDER_CHECKOUT: 'PROVIDER_CHECKOUT',
  PROVIDER_CHECKOUT_RESPONSE: 'PROVIDER_CHECKOUT_RESPONSE',
  PROVIDER_CHECKOUT_CLEAR: 'PROVIDER_CHECKOUT_CLEAR',

  PROVIDER_PLACEORDER: 'PROVIDER_PLACEORDER',
  PROVIDER_PLACEORDER_RESPONSE: 'PROVIDER_PLACEORDER_RESPONSE',
  PROVIDER_PLACEORDER_CLEAR: 'PROVIDER_PLACEORDER_CLEAR',

  PROVIDER_PLACEORDER_V2: 'PROVIDER_PLACEORDER_V2',
  PROVIDER_PLACEORDER_V2_RESPONSE: 'PROVIDER_PLACEORDER_V2_RESPONSE',
  PROVIDER_PLACEORDER_V2_CLEAR: 'PROVIDER_PLACEORDER_V2_CLEAR',

  SEND_ORDER_PLACE: 'SEND_ORDER_PLACE',
  SEND_ORDER_PLACE_RESPONSE: 'SEND_ORDER_PLACE_RESPONSE',
  SEND_ORDER_PLACE_CLEAR: 'SEND_ORDER_PLACE_CLEAR',

  ZERO_SEND_ORDER_PLACE: 'ZERO_SEND_ORDER_PLACE',
  ZERO_SEND_ORDER_PLACE_RESPONSE: 'ZERO_SEND_ORDER_PLACE_RESPONSE',
  ZERO_SEND_ORDER_PLACE_CLEAR: 'ZERO_SEND_ORDER_PLACE_CLEAR',

  ORDER_PLACED_RESPONSE: 'ORDER_PLACED_RESPONSE',
  ORDER_PLACED_CLEAR: 'ORDER_PLACED_CLEAR',
  CART_PAGE_DATA_RESPONSE: 'CART_PAGE_DATA_RESPONSE',
  CART_PAGE_DATA_CLEAR: 'CART_PAGE_DATA_CLEAR',

  SUBSCRIPTION_CHECKOUT_PAGE: "SUBSCRIPTION_CHECKOUT_PAGE",
  SUBSCRIPTION_CHECKOUT_PAGE_CLEAR: "SUBSCRIPTION_CHECKOUT_PAGE_CLEAR",

  PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE: "PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE",
  PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE_CLEAR: "PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE_CLEAR",

  FETCH_PRODUCT_PI: "FETCH_PRODUCT_PI",
  FETCH_PRODUCT_PI_RES: "FETCH_PRODUCT_PI_RES",
  FETCH_PRODUCT_PI_CLEAR: "FETCH_PRODUCT_PI_CLEAR",

  FETCH_SUBSCRIPTION_PI: "FETCH_SUBSCRIPTION_PI",
  FETCH_SUBSCRIPTION_PI_RES: "FETCH_SUBSCRIPTION_PI_RES",
  FETCH_SUBSCRIPTION_PI_CLEAR: "FETCH_SUBSCRIPTION_PI_CLEAR",

  B2C_MEMBERSHIP_PAYMENT_UPDATE: "B2C_MEMBERSHIP_PAYMENT_UPDATE",
  B2C_MEMBERSHIP_PAYMENT_UPDATE_RES: "B2C_MEMBERSHIP_PAYMENT_UPDATE_RES",
  B2C_MEMBERSHIP_PAYMENT_UPDATE_CLEAR: "B2C_MEMBERSHIP_PAYMENT_UPDATE_CLEAR",

  MEMBERSHIP_PAYMENT_DETAIL: "MEMBERSHIP_PAYMENT_DETAIL",
  MEMBERSHIP_PAYMENT_DETAIL_CLEAR: "MEMBERSHIP_PAYMENT_DETAIL_CLEAR",

  PRODUCT_PAYMENT_DETAIL: "PRODUCT_PAYMENT_DETAIL",
  PRODUCT_PAYMENT_DETAIL_CLEAR: "PRODUCT_PAYMENT_DETAIL_CLEAR",

  PROVIDER_PAYMENT_DETAIL: "PROVIDER_PAYMENT_DETAIL",
  PROVIDER_PAYMENT_DETAIL_CLEAR: "PROVIDER_PAYMENT_DETAIL_CLEAR",

  FETCH_SUBSCRIBED_DATA: "FETCH_SUBSCRIBED_DATA",
  FETCH_SUBSCRIBED_DATA_RES: "FETCH_SUBSCRIBED_DATA_RES",
  FETCH_SUBSCRIBED_DATA_CLEAR: "FETCH_SUBSCRIBED_DATA_CLEAR",

  CHANGE_SUBSCRIPTION_PLAN: "CHANGE_SUBSCRIPTION_PLAN",
  CHANGE_SUBSCRIPTION_PLAN_RES: "CHANGE_SUBSCRIPTION_PLAN_RES",
  CHANGE_SUBSCRIPTION_PLAN_CLEAR: "CHANGE_SUBSCRIPTION_PLAN_CLEAR",

  VIEW_SUBSCRIPTION_RECEIPT: "VIEW_SUBSCRIPTION_RECEIPT",
  VIEW_SUBSCRIPTION_RECEIPT_RES: "VIEW_SUBSCRIPTION_RECEIPT_RES",
  VIEW_SUBSCRIPTION_RECEIPT_CLEAR: "VIEW_SUBSCRIPTION_RECEIPT_CLEAR",

  PRE_SUBSCRIPTION_RECEIPT_DATA: "PRE_SUBSCRIPTION_RECEIPT_DATA",
  PRE_SUBSCRIPTION_RECEIPT_DATA_CLEAR: "PRE_SUBSCRIPTION_RECEIPT_DATA_CLEAR",
  COACH_OR_SERVICE_ID_RESPONSE: 'COACH_OR_SERVICE_ID_RESPONSE',
  COACH_OR_SERVICE_ID_RESPONSE_CLEAR: 'COACH_OR_SERVICE_ID_RESPONSE_CLEAR',
  
}

export default types;